<o3-core-table-header
  [kcResource]="kcResource"
  [breadCrumbItems]="breadCrumbItems"
  [breadCrumbHome]="breadCrumbHome"
  (searchValueChange)="handleSearchChange($event)"
  (buttonClick)="handleButtonClick($event)"
></o3-core-table-header>

<div class="view-body">
  <ejs-grid
    #grid
    [id]="viewKey()"
    [width]="width()"
    [height]="height()"
    [allowResizing]="true"
    [dataSource]="listItems()"
    [allowPaging]="true"
    [allowSorting]="true"
    [allowFiltering]="true"
    [showColumnMenu]="false"
    [showColumnChooser]="true"
    [filterSettings]="filterSettings"
    [sortSettings]="sortSettings()"
    [pageSettings]="pageSettings()"
    [allowExcelExport]="true"
    [enablePersistence]="false"
    (recordDoubleClick)="recordDoubleClick($event)"
    (dataStateChange)="dataStateChange($event)"
    (dataSourceChanged)="dataStateChange($event)"
  >
    <ng-template #toolbarTemplate let-data>
      <o3-core-grid-toolbar
        (buttonClick)="handleButtonClick($event)"
        (searchValueChange)="handleSearchChange($event)"
      />
    </ng-template>

    <e-columns>
      <e-column
        headerText="..."
        width="70"
        [allowFiltering]="false"
        [allowSorting]="false"
        [allowGrouping]="false"
        [allowReordering]="false"
        freeze="Right"
      >
        <ng-template #template let-data>
          <button
            type="button"
            class="e-btn e-flat e-primary"
            [title]="'viewDetail' | translate"
            (click)="editRecord(data)"
          >
            <span class="ti ti-eye icon-md"></span>
          </button>
        </ng-template>
      </e-column>

      <e-column
        field="status"
        type="string"
        [headerText]="'status' | translate"
        width="140"
      >
        <ng-template #template let-data>
          <span
            class="status-badge"
            [style.background-color]="getStatusColor(data.status)"
            [style.color]="getStatusFgColor(data.status)"
          >
            {{ getStatusName(data.status) }}
          </span>
        </ng-template>
      </e-column>

      <e-column
        field="recipientPhone"
        type="string"
        [headerText]="'recipientPhone' | translate"
        width="160"
      ></e-column>

      <e-column
        field="messageContent"
        type="string"
        [headerText]="'messageContent' | translate"
      >
        <ng-template #template let-data>
          <span class="message-preview" [title]="data.messageContent">
            {{ data.messageContent | slice: 0 : 100
            }}{{ data.messageContent?.length > 100 ? "..." : "" }}
          </span>
        </ng-template>
      </e-column>

      <e-column
        field="sendItOn"
        type="date"
        [headerText]="'sendItOn' | translate"
        [format]="organizationConfigService.DateTimeFormat"
      ></e-column>

      <e-column
        field="sentAt"
        type="date"
        [headerText]="'sentAt' | translate"
        [format]="organizationConfigService.DateTimeFormat"
      ></e-column>

      <e-column
        field="retryCount"
        type="number"
        [headerText]="'retryCount' | translate"
        width="110"
        textAlign="Center"
      ></e-column>

      <e-column
        field="failureReason"
        type="string"
        [headerText]="'failureReason' | translate"
        width="200"
      ></e-column>

      <e-column
        field="tenantId"
        type="string"
        [headerText]="'tenantId' | translate"
        width="120"
      ></e-column>

      <e-column
        field="createdAt"
        type="date"
        [headerText]="'createdAt' | translate"
        [format]="organizationConfigService.DateTimeFormat"
      ></e-column>
    </e-columns>
  </ejs-grid>

  @if (listItems().result.length === 0 && !loading()) {
    <o3-core-grid-no-data />
  }
</div>
